export default __webpack_public_path__ + "static/ipad-f07a8229a025e906e657be2461b9de85.png";